import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

const GeneralSettingsPage = () => {
  // TODO: Implement general IT management settings
  // This is a placeholder that will be implemented later

  return (
    <div style={{ width: '100%', padding: '24px 48px' }}>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '8px' }}>
          {i18n.t('it_management.settings.general_settings.title')}
        </h1>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          {i18n.t('it_management.settings.general_settings.description')}
        </p>
      </div>

      <div style={{ padding: '48px 0', textAlign: 'center' }}>
        <p style={{ color: '#9ca3af', fontSize: '14px' }}>
          {i18n.t('it_management.settings.general_settings.placeholder')}
        </p>
      </div>
    </div>
  )
}

export default React.memo(GeneralSettingsPage)
